export default "__VITE_ASSET__572312ac__"